/**
 * state sets the initial state for vuex
 * @module state
 */
export default {

    /**
     * holds data on all events
     * @type {object}
     */
    events: {},

    /**
     * firstname of user
     * @type {string}
     */
    firstname: "",


    /**
     * surname of user
     * @type {string}
     */
    surname: "",


    /**
     * email of user
     * @type {string}
     */
    email: "",

    /**
     * postcode of user
     * @type {string}
     */
    postcode: "",

    /**
     * highestQualification of user
     * @type {string}
     */
    highestQualification: "",

    /**
     * divisionalInformation
     * @type {string}
     */
    divisionalInformation: "",

    /**
     * currentStudy Programme
     */
    currentStudyProgramme: "",

    /**
     * holds the currently selected modules
     * @type {array}
     * @example
     * [
     *     "O16TEST1",
     *     "O16TEST2",
     *     ...
     * ]
     */
    selectedModules: [],

    /**
     * holds the currently clashing modules
     * @type {array}
     * @example
     * [
     *     ["O16TEST1", "O16TEST2"],
     *     ...
     * ]
     */
    clashingModules: [],


    /**
     * events (represented by ids) in date order
     * @type {array}
     * @example
     * [10, 9],
     */
    dateOrderEvents: [],

    /**
     * events (represented by ids) in name order
     * @type {array}
     * @example
     * [10, 9],
     */
    nameOrderEvents: [],

    /**
     * the 'url' part (after /list/) of the current url,
     * used to look up the event
     * @type {string}
     */
    currentSingleEventUrl: "",

    /**
     * the current event, found by matching the
     * currentSingleEventUrl to the matching
     * event.
     * @summary the current event
     * @type {object}
     */
    currentSingleEvent: {},


    /**
     * the format (used in moment dates) for dates
     * @type {string}
     */
    dateFormat: "YYYY-MM-DD",


    /**
     * the format (used in moment dates) for times
     * @type {string}
     */
    timeFormat: "HH:mm:ss",


    /**
     * data on all loaded modules
     * @example
     * {
     *     O16TEST: {
     *         title: "Foo",
     *         ...
     *     },
     *     ...
     * }
     * @type {object}
     */
    modules: {},


    /**
     * a pairing of dates and modules
     * @example
     * {
     *     "1921-04-31": [
     *         "O16TEST1",
     *         "O16TEST2",
     *      ]
     *      ...
     * }
     * @type {object}
     */
    dateModules: {},


    /**
     * a list of ordered dates
     * @example
     * [ "1921-04-01", "1921-04-02" ... ]
     * @type {array}
     */
    moduleDayDateOrder: [],


    /**
     * used to determine which event was last loaded
     * @type number
     * @default -1
     */
    lastLoadedEvent: -1,

    /**
     * @type boolean
     * @default false
     */
    dataProtection: false,

    /**
     * @type boolean
     * @default false
     */
    emailOptin: false,

    /**
     * @type boolean
     * @default false
     */
    overEighteenOptin: false,

    /**
     * length in milliseconds for errors to display
     * @type number
     */
    errorWaitTime: 10000,

    /**
     * the registration status of different modules
     */
    registered: {
        event: false,
        modules: false,
    }

}



// WEBPACK FOOTER //
// ./src/store/state.js